import { useState } from 'react'
import classNames from 'classnames'

import IconZaiAnimation from 'components/IconZaiAnimation'
import TagIcon from 'components/TagIcon'

import { DEFAULT_ZAI_TAG_BUTTON_ICON_COLOR, ICON_SIZE } from './zai-tag-button.consts'
import type { IZaiTagButtonProps, TZaiTagButtonIconMap } from './zai-tag-button.types'

import './zai-tag-button.styles.scss'

export default function ZaiTagButton({ onClick, children, className, variant = 'default' }: IZaiTagButtonProps) {
  const [color, setColor] = useState(DEFAULT_ZAI_TAG_BUTTON_ICON_COLOR)
  const [isIconAnimating, setIsIconAnimating] = useState(false)

  function handleMouseEnter() {
    setIsIconAnimating(true)
    setColor('var(--color_primary_300)')
  }

  function handleMouseLeave() {
    setIsIconAnimating(false)
    setColor(DEFAULT_ZAI_TAG_BUTTON_ICON_COLOR)
  }

  const iconByVariant: TZaiTagButtonIconMap = {
    default: <IconZaiAnimation isAnimating={isIconAnimating} size={ICON_SIZE} />,
    purple: <IconZaiAnimation isAnimating={isIconAnimating} color={color} size={ICON_SIZE} />,
    christmas: <span style={ICON_SIZE}>🎄</span>,
  }

  return (
    <button
      className={classNames('ZaiTagButton', className, variant)}
      data-testid="zai-tag-button"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
    >
      <TagIcon icon={iconByVariant[variant]} className="ZaiTagButton-content">
        {children}
      </TagIcon>
    </button>
  )
}
